import http from "../helper/http";
import * as urls from "../config/urls";
import axios from 'axios';

const CancelToken = axios.CancelToken;
let listCancel;

export default {
  fetchFloorings(query) {
    if (listCancel !== undefined) {
      listCancel();
    }
    return new Promise((resolve, reject) => {
      http.get(`${urls.FLOORING}${query ? `?${query}`: ''}`, {cancelToken: new CancelToken((c) => {listCancel = c;})})
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
};
